import { eventBus, EVENTS } from './EventBus.js';
import Utils from './utils.js';

const fbEvents=[];

window.__counterRefresh = 0;
var evento = { type: null };
let waitingEvents = [];
let doNotTrack=false;
let doNotTrackDiretta=false;
let doNotTrackDirettaVideo=false;
const WEBT_RDS_TITLE = 'Live RDS - audio - rds.it';                    //OLD: "web - live – Diretta Radio";  || 'web - live - Live RDS SOCIAL TV - audio - rds.it'
const WEBT_SERIEA_TITLE = 'Live Radio Serie A - audio - rds.it';         //OLD: 'web - live – Diretta Radio Serie A';
const WEBT_VIDEO_RDS_TITLE = 'Live RDS SOCIAL TV - video - rds.it';              // OLD: "web - live – Diretta Video";
const WEBT_VIDEO_SERIEA_TITLE = 'Live Radio Serie A - video - rds.it';   //OLD: 'web - live – Diretta Video Serie A';


eventBus.on(EVENTS.PLAYER_PODCAST_NEW_SONG, (event) => {
    evento = event;
    evento.ready = false;
    if (playerPodcast.waitPreroll) {
        doNotTrack=true;
        playerPodcast.player.on('IMA_END', () => {
            doNotTrack=false;
            playerPodcast.player.one('loadedmetadata', () => {
                evento.ready = true;
                for (const ev of waitingEvents) {
                    ev();
                }
                waitingEvents = [];
            });
        });
    } else {
        playerPodcast.player.one('loadedmetadata', () => {
            evento.ready = true;
            for (const ev of waitingEvents) {
                ev();
            }
            waitingEvents = [];
        });
    }
});

var init_player_diretta = false;
var init_player_diretta_video = false;
var snapshot_podcast = 0;
var snapshot_vod = 0;
var snapshot_diretta = 0;
var snapshot_onair = 0;

let today;

class Analytics {

    init() {
        today=this.trimDate();
        // inizializzo oggetto webtrekk
        try {
            this.init_webtrekk();
        } catch (error) {
            console.warn(error);
        }
        try {
            if (window.ga) {
                this.init_google_analytics();
            }
        } catch (error) {
            console.warn(error);
        }
        try {
          this.initTiktokListener();
        }catch (error) {
          console.warn(error);
        }
        this.initGenericListener();
        setInterval(() => {
            this.check_refresh_page();
        }, 2.5 * 60 * 1000 );// 2.5 * 60 * 1000



        // inizializzazione Google Analytics a


    }

  trimDate() {
    let d = new Date();
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    let separator = '-';
    return `${day}${separator}${month}${separator}${year}`;
  }

    /*** WEBTREKK ***/

    init_webtrekk() {
        // console.log("init webtrekk");
        window.webtrekk_dl = {};
        this.webtrekk_listeners();
    }

    async sendEventAnalyticsMedia(params) {
      //wt_sendinfo_media("web - podcast - " + evento.titolo, "init", playerPodcast.currentTime(), playerPodcast.duration, "mg1=" + evento.titolo + ";mg2=web;mg3=podcast;mg4=" + evento.categoria, "0", volume, muted);
      /*let params = {
        source: 'web',
        type: type,
        title: evento.titolo,
        event:'init',
        currentTime: playerPodcast.currentTime(),
        duration: playerPodcast.duration,
        category: evento.categoria,
        volume: volume,
        muted: muted,
        videoSrc: evento.videoSrc.src,
        videoPoster: evento.immagine
      };*/
      const eventCategory = params.source + ' - ' + params.type;
      const eventAction = params.title + ' - ' + params.event;
      const eventWt = params.source + ' - ' + params.type + ' - ' + params.title;
      //"mg1=" + evento.titolo + ";mg2=web;mg3=podcast;mg4=" + evento.categoria
      wt_sendinfo_media(eventWt, params.event, params.currentTime, params.duration, params.mgParam, "0", params.volume, params.muted);
      await this.sendEventAnalytics(eventCategory, eventAction, null, true);
    }

    async sendEventAnalytics(eventCategory, eventAction, additionalParams = null, isMedia = false) {

      // const wtParams = analytics_params.wt;
      // const fbParams = analytics_params.fb;
      // const gaParams = analytics_params.ga;
      const FB_TRACK_TYPE = 'trackCustom';
      const HIT_TYPE = 'event';

      let eventName = `${eventCategory} - ${eventAction}`;

      let wt_eventParams = {1: `${eventName}`};

      const url = additionalParams && additionalParams.url ? additionalParams.url : '';

      /**
       * Parametri da passare per le chiamate ga
       * eventLabel
       * eventValue
       * fieldsObject
       */

      // webtrekk
      if (!isMedia){
        this.webtrekk_send_event(eventName, wt_eventParams);
      }

      //fb
      this.fbq(FB_TRACK_TYPE, eventName, {url: url});

      //google analytics
      const ga_params = {
        eventCategory: eventCategory,
        eventAction: eventAction,
        page: url
      };
      this.gtag(HIT_TYPE, eventName, ga_params);

      await this.sendTiktokAnalytics(eventName,eventCategory, eventAction);
    }

    async sendTiktokAnalytics(eventName, eventCategory, eventAction) {
      const now = new Date().toISOString();
      const {email, phone, external_id} = await this.getUserData();
      const ip = await this.getIP();

      const tiktokParams = {
        brand: 'RDS - web',
        content_id: null,
        content_type: null,
        description: null,
        query: '',
        content_category: eventCategory,
        content_name: eventAction,
        event_time: now,
        url: window.location.href,
        email: email,
        phone: phone,
        external_id: external_id,
        // ttclid: 'E.C.P.',
        ip: ip,
        user_agent: window.navigator.userAgent
      };

      await this.ttq(eventName.replaceAll('-','_').replaceAll('.','').replaceAll(' ',''), tiktokParams);
    }

    async getUserData() {
      const _user = user.getLocalUser();
      if (!_user) {
        return {
          "email": null,
          "phone_number": null,
          "external_id": null
        }
      }
      // debugger;
      let params = {
        "email": await this.toSHA256(_user.email), // string. The email of the customer if available. It must be hashed with SHA-256 on the client side.
        "phone_number": null, // string. The phone number of the customer if available. It must be hashed with SHA-256 on the client side.
        "external_id": await this.toSHA256(_user.userid) // string. Any unique identifier, such as loyalty membership IDs, user IDs, and external cookie IDs.It must be hashed with SHA-256 on the client side.
      };
      if (_user.phone_confirmed) {
        params.phone_number = await this.toSHA256(_user.telefono);
      }
      return params;
    }

    async toSHA256(string) {
      const encoder = new TextEncoder();
      const arrayBuffer = encoder.encode(string);
      const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
      const byteArray = new Uint8Array(hashBuffer);
      const hexString = byteArray.reduce((acc, byte) => {
        return acc + byte.toString(16).padStart(2, '0');
      }, '');
      return hexString;
    }

    async getIP() {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    }

    webtrekk_listeners() {

        eventBus.on(EVENTS.PAGE_AFTER_RENDERING, (content) => {
            this.webtrekk_page_update(content);
        });
      eventBus.on(EVENTS.TRACK_PAGE, (content) => {
        this.webtrekk_page_update(content);
      });

        eventBus.on(EVENTS.USER_LOGIN, () => {
            this.webtrekk_send_event('click-iscrizione', { 1: "iscriviti e accedi" });
        });

        eventBus.on(EVENTS.USER_LOGOUT, () => {
            this.webtrekk_send_event('click-menu', { 1: "logout" });
        });

        eventBus.on(EVENTS.USER_CLICK_REGISTER_BUTTON, () => {
            this.webtrekk_send_event('click-registrazione', { 1: 'iscriviti' });
        });

        eventBus.on(EVENTS.USER_REGISTER_OK, () => {
            this.webtrekk_send_event('click-registrazione', { 1: 'registrazione avvenuta con successo' });
        });

        // PLAYER PODCAST (INIT)
        const onNewSong = async () => {
          let type = 'sample audio'
          const volume = Math.round(playerPodcast.player.volume()*100);
          const muted = videoPlayer.player.muted() ? "1" : "0";
          if (!evento.ready) {
            waitingEvents.push(onNewSong);
            return;
          }
          let mgParam ;
          switch (evento.type) {
            case "podcast":
              mgParam = "mg1=" + evento.titolo + ";mg2=web;mg3=podcast;mg4=" + evento.categoria;
              type='podcast';
              break;
            case "videoPodcast":
              mgParam = "mg1=" + evento.titolo + ";mg2=web;mg3=vod;mg4=" + evento.categoria + ";mg14=" + evento.videoSrc.src + ";mg15=" + evento.immagine;
              type='vod';
              break;
            case "song":
              mgParam = "mg1=" + evento.titolo + ";mg2=web;mg3=sample audio;mg4=" + evento.categoria;
              type='sample audio';
              break;
            default:
              break;
          }
          let params = {
            source: 'web',
            type: type,
            title: evento.titolo,
            event:'init',
            currentTime: playerPodcast.currentTime(),
            duration: playerPodcast.duration,
            category: evento.categoria,
            volume: volume,
            muted: muted,
            videoSrc: evento.videoSrc.src,
            videoPoster: evento.immagine,
            mgParam: mgParam
          };
          await this.sendEventAnalyticsMedia(params);
          //gfkS2s send
          window.extensionPodcast.setParameter({
            customParams : {
              channel: '',
              format: 'audio',
              type: type,
            }
          });
        };
        eventBus.on(EVENTS.PLAYER_PODCAST_NEW_SONG, onNewSong);

        // PLAYER PODCAST (PLAY)
        const onPlay = async () => {
          const volume = Math.round(playerPodcast.player.volume() * 100);
          const muted = videoPlayer.player.muted() ? "1" : "0";
          if (doNotTrack || $('.mol-video-ad-container').length) {
            return;
          }
          if (!evento.ready) {
            waitingEvents.push(onPlay);
            return;
          }
          let mgParam;
          let type;
          switch (evento.type) {
            case "podcast":
              mgParam = "mg1=" + evento.titolo + ";mg2=web;mg3=podcast;mg4=" + evento.categoria + ";ck12=n;ck13=n";
              type = 'podcast';
              break;
            case "videoPodcast":
              mgParam = "mg1=" + evento.titolo + ";mg2=web;mg3=vod;mg4=" + evento.categoria + ";mg14=" + evento.videoSrc.src + ";mg15=" + evento.immagine + ";ck12=n;ck13=n";
              type = 'vod';
              break;
            case "song":
              mgParam = "mg1=" + evento.titolo + ";mg2=web;mg3=sample audio;mg4=" + evento.categoria + ";ck12=n;ck13=n";
              type = 'sample audio';
              break;
            default:
              break;
          }
          let params = {
            source: 'web',
            type: type,
            title: evento.titolo,
            event: 'play',
            currentTime: playerPodcast.currentTime(),
            duration: playerPodcast.duration,
            category: evento.categoria,
            volume: volume,
            muted: muted,
            videoSrc: evento.videoSrc.src,
            videoPoster: evento.immagine,
            mgParam: mgParam
          };
          await this.sendEventAnalyticsMedia(params);
          // if (evento.type == "podcast") {
          //   console.log("wt_sendinfo_media > podcast > play");
          //   this.fbq('trackCustom','Podcast - play', {title:evento.titolo});
          //   wt_sendinfo_media("web - podcast - " + evento.titolo, "play", playerPodcast.currentTime(), playerPodcast.duration, "mg1=" + evento.titolo + ";mg2=web;mg3=podcast;mg4=" + evento.categoria + ";ck12=n;ck13=n", "0", volume, muted);
          // } else if (evento.type == "videoPodcast") {
          //   console.log("wt_sendinfo_media > videoPodcast > play");
          //   this.fbq('trackCustom','Video Podcast - play', {title:evento.titolo});
          //   wt_sendinfo_media("web - vod - " + evento.titolo, "play", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          // } else if (evento.type == "song") {
          //   console.log("wt_sendinfo_media > song > play");
          //   wt_sendinfo_media("web - sample audio - " + evento.titolo, "play", playerPodcast.currentTime(), playerPodcast.duration, "mg1=" + evento.titolo + ";mg2=web;mg3=sample audio;mg4=" + evento.categoria + ";ck12=n;ck13=n", "0", volume, muted);
          // }
        };
        playerPodcast.on('trackplay', onPlay);

        // PLAYER PODCAST (PAUSA)
        const onPause = async () => {
          const volume = Math.round(playerPodcast.player.volume() * 100);
          const muted = videoPlayer.player.muted() ? "1" : "0";
          if (doNotTrack || playerPodcast.waitPreroll) {
            return;
          }
          if (!evento.ready) {
            waitingEvents.push(onPause);
            return;
          }
          let mgParam = "ck12=n;ck13=n";
          let type;
          switch (evento.type) {
            case "podcast":
              type = 'podcast';
              break;
            case "videoPodcast":
              type = 'vod';
              break;
            case "song":
              type = 'sample audio';
              break;
            default:
              break;
          }
          let params = {
            source: 'web',
            type: type,
            title: evento.titolo,
            event: 'pause',
            currentTime: playerPodcast.currentTime(),
            duration: playerPodcast.duration,
            category: evento.categoria,
            volume: volume,
            muted: muted,
            videoSrc: evento.videoSrc.src,
            videoPoster: evento.immagine,
            mgParam: mgParam
          };
          await this.sendEventAnalyticsMedia(params);
          // if (evento.type == "podcast") {
          //   console.log("wt_sendinfo_media > podcast > pause");
          //   this.fbq('trackCustom','Podcast - pause', {title:evento.titolo});
          //   wt_sendinfo_media("web - podcast - " + evento.titolo, "pause", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          // } else if (evento.type == "videoPodcast") {
          //   console.log("wt_sendinfo_media > videoPodcast > pause");
          //   this.fbq('trackCustom','Video Podcast - pause', {title:evento.titolo});
          //   wt_sendinfo_media("web - vod - " + evento.titolo, "pause", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          // } else if (evento.type == "song") {
          //   console.log("wt_sendinfo_media > song > pause");
          //   wt_sendinfo_media("web - sample audio - " + evento.titolo, "pause", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          // }
        };
        playerPodcast.on('trackstop', onPause);

        // PLAYER PODCAST (FINE DEL FILE)
        const onEnd = async () => {
          const volume = Math.round(playerPodcast.player.volume() * 100);
          const muted = videoPlayer.player.muted() ? "1" : "0";
          if (doNotTrack) {
            return;
          }
          let mgParam = "ck12=n;ck13=n";
          let type;
          switch (evento.type) {
            case "podcast":
              type = 'podcast';
              break;
            case "videoPodcast":
              type = 'vod';
              break;
            case "song":
              type = 'sample audio';
              break;
            default:
              break;
          }
          let params = {
            source: 'web',
            type: type,
            title: evento.titolo,
            event: 'end',
            currentTime: playerPodcast.currentTime(),
            duration: playerPodcast.duration,
            category: evento.categoria,
            volume: volume,
            muted: muted,
            mgParam: mgParam
          };
          await this.sendEventAnalyticsMedia(params);
          // if (evento.type == "podcast") {
          //   console.log("wt_sendinfo_media > podcast > eof");
          //   this.fbq('trackCustom','Podcast - end', {title:evento.titolo});
          //   wt_sendinfo_media("web - podcast - " + evento.titolo, "eof", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          // } else if (evento.type == "videoPodcast") {
          //   console.log("wt_sendinfo_media > videoPodcast > eof");
          //   this.fbq('trackCustom','Video Podcast - end', {title:evento.titolo});
          //   wt_sendinfo_media("web - vod - " + evento.titolo, "eof", playerPodcast.duration, playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted)
          // } else if (evento.type == "song") {
          //   console.log("wt_sendinfo_media > song > eof");
          //   wt_sendinfo_media("web - sample audio - " + evento.titolo, "eof", playerPodcast.duration, playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          // }
        }
        playerPodcast.on('ended', onEnd);

        // PLAYER PODCAST (POS)

        playerPodcast.on('timeupdate', async () => {
          const volume = Math.round(playerPodcast.player.volume() * 100);
          const muted = videoPlayer.player.muted() ? "1" : "0";
          if (doNotTrack) {
            return;
          }
          let mgParam = "ck12=n;ck13=n";
          let snapshot = 0;
          let type;
          switch (evento.type) {
            case "podcast":
              snapshot = snapshot_podcast;
              type = 'podcast';
              break;
            case "videoPodcast":
              snapshot = snapshot_vod;
              type = 'vod';
              break;
            case "song":
              snapshot = snapshot_vod;
              type = 'sample audio';
              break;
            default:
              break;
          }
          let params = {
            source: 'web',
            type: type,
            title: evento.titolo,
            event: 'pos',
            currentTime: playerPodcast.currentTime(),
            duration: playerPodcast.duration,
            category: evento.categoria,
            volume: volume,
            muted: muted,
            videoSrc: evento.videoSrc.src,
            videoPoster: evento.immagine,
            mgParam: mgParam
          };
          if (playerPodcast.currentTime() - snapshot_podcast > 30) {
            await this.sendEventAnalyticsMedia(params);
          }
          // if (evento.type == "podcast") {
          //   if (playerPodcast.currentTime() - snapshot_podcast > 30) {
          //     snapshot_podcast = playerPodcast.currentTime();
          //     console.log("wt_sendinfo_media > podcast > pos");
          //     wt_sendinfo_media("web - podcast - " + evento.titolo, "pos", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          //   }
          // } else if (evento.type == "videoPodcast") {
          //   if (playerPodcast.currentTime() - snapshot_vod > 30) {
          //     snapshot_vod = playerPodcast.currentTime();
          //     console.log("wt_sendinfo_media > videoPodcast > pos");
          //     wt_sendinfo_media("web - vod - " + evento.titolo, "pos", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          //   }
          // }
          // else if (evento.type == "song") {
          //   if (playerPodcast.currentTime() - snapshot_vod > 30) {
          //     snapshot_vod = playerPodcast.currentTime();
          //     console.log("wt_sendinfo_media > videoPodcast > pos");
          //     wt_sendinfo_media("web - sample audio - " + evento.titolo, "pos", playerPodcast.currentTime(), playerPodcast.duration, "ck12=n;ck13=n", "0", volume, muted);
          //   }
          // }
        });

        // DIRETTA (INIT)
        if (mainPlayer.waitPreroll) {
            doNotTrackDiretta=true;
            mainPlayer.player.on('IMA_END', () => {
                doNotTrackDiretta=false;
            });
        }
        mainPlayer.on('trackplay', async () => {
          const volume = Math.round(mainPlayer.player.volume() * 100);
          const muted = mainPlayer.player.muted() ? "1" : "0";
          if (doNotTrackDiretta) {
            return;
          }
          let mgParam;
          let title;
          if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8") {
            // label = WEBT_RDS;
            mgParam = `mg1=Live RDS - rds.it;mg2=web;mg3=live;mg4=Live RDS;mg5=${today};mg6=RDS`;
            title = WEBT_RDS_TITLE;//"Live RDS - audio - rds.it";
          } else {
            // label = WEBT_SERIEA;
            mgParam = `mg1=Live Radio Serie A - audio - rds.it;mg2=web;mg3=live;mg4=Live Radio Serie A;mg5=${today};mg6=RADIO SERIE A`;
            title = WEBT_SERIEA_TITLE;//"Live Radio Serie A - audio - rds.it";
          }
          /*
        const WEBT_RDS = 'web - live - Live RDS - audio - rds.it';
        const WEBT_SERIEA = 'web - live - Live Radio Serie A - audio - rds.it';
         */

          let params = {
            source: 'web',
            type: "live",
            title: title,
            event: 'play',
            currentTime: '0',
            duration: '0',
            category: evento.categoria,
            volume: volume,
            muted: muted,
            mgParam: mgParam
          };

          if (!init_player_diretta) {
            init_player_diretta = true;
            params.event = 'init';
            console.log("wt_sendinfo_media > diretta > init");
            // if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8"){
            //   wt_sendinfo_media(WEBT_RDS, "init", "0", "0", `mg1=Live RDS - rds.it;mg2=web;mg3=live;mg4=Live RDS;mg5=${today};mg6=RDS`, "0", volume, muted);
            // }else{
            //   wt_sendinfo_media(WEBT_SERIEA, "init", "0", "0", `mg1=Live Radio Serie A - audio - rds.it;mg2=web;mg3=live;mg4=Live Radio Serie A;mg5=${today};mg6=RADIO SERIE A`, "0", volume, muted);
            // }
            await this.sendEventAnalyticsMedia(params);

            params.event = 'play';
          }

          params.mgParam = mgParam + ";ck12=n;ck13=n";
          this.sendEventAnalyticsMedia(params);
          console.log("wt_sendinfo_media > diretta > play");
          // if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8"){
          //   wt_sendinfo_media(WEBT_RDS, "play", "0", "0",`mg1=Live RDS - rds.it;mg2=web;mg3=live;mg4=Live RDS;mg5=${today};mg6=RDS; ck12=n;ck13=n`, "0", volume, muted);
          // }else{
          //   wt_sendinfo_media(WEBT_SERIEA, "play", "0", "0", `mg1=Live Radio Serie A - audio - rds.it;mg2=web;mg3=live;mg4=Live Radio Serie A;mg5=${today};mg6=RADIO SERIE A; ck12=n;ck13=n`, "0", volume, muted);
          // }
        });

        // DIRETTA (PAUSA)

        mainPlayer.on('trackstop', async () => {
          const volume = Math.round(mainPlayer.player.volume() * 100);
          const muted = mainPlayer.player.muted() ? "1" : "0";
          if (doNotTrackDiretta) {
            return;
          }
          let title;
          if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8") {
            // label = WEBT_RDS;
            title = WEBT_RDS_TITLE;//"Live RDS - audio - rds.it";
          } else {
            // label = WEBT_SERIEA;
            title = WEBT_SERIEA_TITLE;//"Live Radio Serie A - audio - rds.it";
          }
          console.log("wt_sendinfo_media > diretta > stop");
          const mgParam = "ck12=n;ck13=n";
          let params = {
            source: 'web',
            type: "live",
            title: title,
            event: 'stop',
            currentTime: Math.round(mainPlayer.currentTime()),
            duration: '0',
            category: evento.categoria,
            volume: volume,
            muted: muted,
            mgParam: mgParam
          };
          await this.sendEventAnalyticsMedia(params);
          // if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8"){
          //   wt_sendinfo_media(WEBT_RDS, "stop", Math.round(mainPlayer.currentTime()), "0", "ck12=n;ck13=n", "0", volume, muted);
          // }else{
          //   wt_sendinfo_media(WEBT_SERIEA, "stop", Math.round(mainPlayer.currentTime()), "0", "ck12=n;ck13=n", "0", volume, muted);
          // }
          snapshot_onair=0;
          snapshot_diretta=0;
        });

        // DIRETTA (STOP)

        mainPlayer.on('stop', () => {
            if(doNotTrackDiretta){
                return;
            }
            console.log("wt_sendinfo_media > diretta > stop");

        });

        // DIRETTA (POS) e (ON-AIR)

        mainPlayer.on('timeupdate', async () => {
          const volume = Math.round(mainPlayer.player.volume() * 100);
          const muted = mainPlayer.player.muted() ? "1" : "0";
          if (doNotTrackDiretta) {
            return;
          }
          let title;
          let mgParam = "ck9=" + $("#player_onair_title").html().replace('&amp;', 'e') + ";ck12=n;ck13=n";
          if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8") {
            // label = WEBT_RDS;
            title = WEBT_RDS_TITLE;//"Live RDS - audio - rds.it";
          } else {
            // label = WEBT_SERIEA;
            title = WEBT_SERIEA_TITLE;//"Live Radio Serie A - audio - rds.it";
          }
          console.log("wt_sendinfo_media > diretta > timeupdate");
          let params = {
            source: 'web',
            type: "live",
            title: title,
            // event:'stop',
            currentTime: Math.round(mainPlayer.currentTime()),
            duration: '0',
            category: evento.categoria,
            volume: volume,
            muted: muted,
            mgParam: mgParam
          };
          if (mainPlayer.currentTime() - snapshot_diretta > 30) {
            params.event = 'pos';
            snapshot_diretta = mainPlayer.currentTime();
            console.log("wt_sendinfo_media > diretta > pos");
            await this.sendEventAnalyticsMedia(params);
          }

          if (mainPlayer.currentTime() - snapshot_onair > 120) {
            snapshot_onair = mainPlayer.currentTime();
            console.log("wt_sendinfo_media > diretta > on-air");
            params.event = 'on-air';
            await this.sendEventAnalyticsMedia(params);
          }

          //   if (mainPlayer.getSource() == "https://stream.rds.radio/audio/rds.stream_aac/playlist.m3u8"){
          //     wt_sendinfo_media(WEBT_RDS, "on-air", Math.round(mainPlayer.currentTime()), "0", , "0", volume, muted);
          //   }else{
          //     wt_sendinfo_media(WEBT_SERIEA, "on-air", Math.round(mainPlayer.currentTime()), "0", "ck9=" + $("#player_onair_title").html().replace('&amp;', 'e') + ";ck12=n;ck13=n", "0", volume, muted);
          //   }
          // }
        });


      if (videoPlayer.waitPreroll) {
        doNotTrackDirettaVideo=true;
        videoPlayer.player.on('trackplay', () => {
          doNotTrackDirettaVideo=false;
        });
      }
      // TRACCIAMENTI VIDEOPLAYER
      videoPlayer.on('trackplay', async () => {
        const volume = Math.round(videoPlayer.player.volume() * 100);
        const muted = videoPlayer.player.muted() ? "1" : "0";
        if (doNotTrackDirettaVideo) {
          return;
        }

        let mgParam;
        let title;
        if (videoPlayer.getSource() == "https://stream.rdstv.radio/index.m3u8") {
          // label = WEBT_RDS;
          mgParam = `mg1=Live RDS SOCIAL TV - rds.it;mg2=web;mg3=live;mg4=Live RDS Social TV;mg5=${today};mg6=RDS`;
          title = WEBT_VIDEO_RDS_TITLE;//"Live RDS SOCIAL TV - video - rds.it";
        } else {
          // label = WEBT_SERIEA;
          mgParam = `mg1=Live Radio Serie A - video - rds.it;mg2=web;mg3=live;mg4=Live Radio Serie A;mg5=${today};mg6=RDS`;
          title = WEBT_VIDEO_SERIEA_TITLE;//"Live Radio Serie A - video - rds.it";
        }

        let params = {
          source: 'web',
          type: "live",
          title: title,
          event: 'play',
          currentTime: '0',
          duration: '0',
          category: evento.categoria,
          volume: volume,
          muted: muted,
          mgParam: mgParam
        };

        if (!init_player_diretta) {
          init_player_diretta = true;
          params.event = 'init';
          console.log("wt_sendinfo_media > diretta_video > init");
          await this.sendEventAnalyticsMedia(params);

          params.event = 'play';
        }

        params.mgParam = mgParam + ";ck12=n;ck13=n";
        await this.sendEventAnalyticsMedia(params);

        console.log("wt_sendinfo_media > diretta_video > play");
        // if (videoPlayer.getSource() == "https://stream.rdstv.radio/index.m3u8"){
        //   wt_sendinfo_media(WEBT_VIDEO_RDS, "play", "0", "0", `mg1=Live RDS SOCIAL TV - rds.it;mg2=web;mg3=live;mg4=Live RDS Social TV;mg5=${today};mg6=RDS; ck12=n;ck13=n`, "0", volume, muted);
        // }else{
        //   wt_sendinfo_media(WEBT_VIDEO_SERIEA, "play", "0", "0", `mg1=Live Radio Serie A - video - rds.it;mg2=web;mg3=live;mg4=Live Radio Serie A;mg5=${today};mg6=RDS;ck12=n;ck13=n`, "0", volume, muted);
        // }
      });

      videoPlayer.on('trackstop', async () => {
        console.log('****************** waitPreroll',videoPlayer.waitPreroll);

        const volume = Math.round(videoPlayer.player.volume()*100);
        const muted = videoPlayer.player.muted() ? "1" : "0"
        if(doNotTrackDirettaVideo){
          return;
        }
        let title;
        if (videoPlayer.getSource() == "https://stream.rdstv.radio/index.m3u8"){
          // label = WEBT_RDS;
          title = WEBT_VIDEO_RDS_TITLE;//"Live RDS - audio - rds.it";
        }else{
          // label = WEBT_SERIEA;
          title = WEBT_VIDEO_SERIEA_TITLE;//"Live Radio Serie A - audio - rds.it";
        }
        console.log("wt_sendinfo_media > diretta_video > stop");
        const mgParam = "ck12=n;ck13=n";
        let params = {
          source: 'web',
          type: "live",
          title: title,
          event:'stop',
          currentTime: Math.round(videoPlayer.currentTime()),
          duration: '0',
          category: evento.categoria,
          volume: volume,
          muted: muted,
          mgParam: mgParam
        };
        await this.sendEventAnalyticsMedia(params);
        console.log("wt_sendinfo_media > diretta_video > stop");
        // if (videoPlayer.getSource() == "https://stream.rdstv.radio/index.m3u8"){
        //   wt_sendinfo_media(WEBT_VIDEO_RDS, "stop", Math.round(videoPlayer.currentTime()), "0", "ck12=n;ck13=n", "0", volume, muted);
        // }else{
        //   wt_sendinfo_media(WEBT_VIDEO_SERIEA, "stop", Math.round(videoPlayer.currentTime()), "0", "ck12=n;ck13=n", "0", volume, muted);
        // }
        snapshot_onair=0;
        snapshot_diretta=0;
      });

      videoPlayer.on('timeupdate', () => {
        const volume = Math.round(videoPlayer.player.volume()*100);
        const muted = videoPlayer.player.muted() ? "1" : "0"
        if(doNotTrackDirettaVideo){
          return;
        }
        let title;
        let mgParam = "ck9=" + $("#player_onair_title").html().replace('&amp;', 'e') + ";ck12=n;ck13=n";
        if (videoPlayer.getSource() == "https://stream.rdstv.radio/index.m3u8"){
          // label = WEBT_RDS;
          title = WEBT_VIDEO_RDS_TITLE;//"Live RDS - audio - rds.it";
        }else{
          // label = WEBT_SERIEA;
          title = WEBT_VIDEO_SERIEA_TITLE;//"Live Radio Serie A - audio - rds.it";
        }
        console.log("wt_sendinfo_media > diretta-video > timeupdate");
        let params = {
          source: 'web',
          type: "live",
          title: title,
          // event:'stop',
          currentTime: Math.round(videoPlayer.currentTime()),
          duration: '0',
          category: evento.categoria,
          volume: volume,
          muted: muted,
          mgParam: mgParam
        };
        if (videoPlayer.currentTime() - snapshot_diretta > 30) {
          params.event = 'pos';
          snapshot_diretta = videoPlayer.currentTime();
          console.log("wt_sendinfo_media > diretta_video > pos");
          this.sendEventAnalyticsMedia(params);
        }

        if (videoPlayer.currentTime() - snapshot_onair > 120) {
          snapshot_onair = videoPlayer.currentTime();
          console.log("wt_sendinfo_media > diretta_video > on-air");
          params.event = 'on-air';
          this.sendEventAnalyticsMedia(params);
        }
      });

      videoPlayer.on('stop', () => {
        if(doNotTrackDirettaVideo){
          return;
        }
        console.log("wt_sendinfo_media > diretta_video > stop");

      });

    }

    webtrekk_page_update(content) {

        window.webtrekk_dl.contentId = (document.location.href || 'no_content').split("?")[0].split("#")[0].toLowerCase();

        var u = user.getLocalUser();

        if (u) {
            window.webtrekk_dl.userStatus = "loggato";
            window.webtrekk_dl.userId = String(u.userid);
        } else {
            window.webtrekk_dl.userStatus = "non loggato";
            window.webtrekk_dl.userId = false;
        }
        if (typeof content != 'undefined' && content.template == "single_post") {
          window.webtrekk_dl.conteggioParole = String(content.conteggioParole);
          window.webtrekk_dl.dataPubblicazione = content.content.date.split('/').reverse().join('-');
        } else {
            window.webtrekk_dl.conteggioParole = false;
            window.webtrekk_dl.dataPubblicazione = false;
        }


        wts.push(["send", "pageupdate"]);

    }

    webtrekk_send_event(eventName, parameters) {

        if (typeof eventName != "string" || eventName.length < 1)
            return;

        var payload = {
            linkId: eventName.replace("'", "").toLowerCase()
        };

        if (typeof parameters == "object") {
            payload.customClickParameter = parameters
        }

        wts.push(["send", "click", payload]);

    }

    /*** GOOGLE ANALYTICS ***/

    init_google_analytics() {

        console.log("init google analytics");

        var ck = Utils.getCookie("_ga");

        if (ck != "") {
            ga('set', { 'dimension2': ck });
        }

        if (window.gaiframe) {
            setInterval(() => {
                this.reset_google_analytics();
            }, 1000 * 60 * window.garefus);
        } else {
            // this.check_refresh_page();
        }

        this.google_analytics_listeners();

    }

    google_analytics_listeners() {
      const HIT_TYPE= 'event';

      eventBus.on(EVENTS.PAGE_AFTER_RENDERING, (content) => {
            this.google_analytics_send_page_view();
            try {
                fbq('track', 'ViewContent');
            } catch (error) {
                console.warn(error);
            }
        });
      eventBus.on(EVENTS.TRACK_PAGE, (content) => {
        this.google_analytics_send_page_view();
        try {
          fbq('track', 'ViewContent');
        } catch (error) {
          console.warn(error);
        }
      });

        eventBus.on(EVENTS.LIVE_OPEN_MENU, (content) => {
          const ga_params = {
            eventCategory:'Diretta',
            eventAction: 'apertura tendina',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            //ga('send', 'event', 'Diretta', 'apertura tendina', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_CLOSE_MENU, (content) => {
          const ga_params = {
            eventCategory:'Diretta',
            eventAction: 'chiusura tendina',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Diretta', 'chiusura tendina', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_PLAY, (content) => {
          const ga_params = {
            eventCategory:'Diretta',
            eventAction: 'play',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Diretta', 'play', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_PAUSE, (content) => {
          const ga_params = {
            eventCategory:'Diretta',
            eventAction: 'pausa',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Diretta', 'pausa', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_LYRICS_DROPDOWN, (content) => {
          const ga_params = {
            eventCategory:'Diretta',
            eventAction: 'lyrics (tendina)',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Diretta', 'lyrics (tendina)', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_LYRICS_BUTTON, (content) => {
          const ga_params = {
            eventCategory:'Diretta',
            eventAction: 'lyrics (bottone)',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Diretta', 'lyrics (bottone)', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_CHAT_DROPDOWN, (content) => {
          const ga_params = {
            eventCategory:'Messaggi',
            eventAction: 'apertura',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Messaggi', 'apertura', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.LIVE_CHAT_SEND, (content) => {
          const ga_params = {
            eventCategory:'Messaggi',
            eventAction: 'invio',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Messaggi', 'invio', 0, 0, { hitCallback: function () { } });
        });

        playerPodcast.on('trackplay', () => {
          let evtCategory = '';
          if (evento.type == 'song') {
            evtCategory = 'Canzone';
          } else if (evento.type == 'podcast') {
            evtCategory = 'Podcast audio';
          } else if (evento.type == 'videoPodcast') {
            evtCategory = 'Podcast video';
          }
          // ga('send', 'event', 'Podcast video', 'play', 0, 0, { hitCallback: function () { } });
          const ga_params = {
            eventCategory: evtCategory,
            eventAction: 'play',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
        });

        playerPodcast.on('trackstop', () => {
          let evtCategory = '';
          if (evento.type == 'song') {
            evtCategory = 'Canzone';
          } else if (evento.type == 'podcast') {
            evtCategory = 'Podcast audio';
          } else if (evento.type == 'videoPodcast') {
            evtCategory = 'Podcast video';
          }
          const ga_params = {
            eventCategory: evtCategory,
            eventAction: 'pause',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
          // ga('send', 'event', 'Podcast video', 'pausa', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.SONG_FAVORITE, (content) => {
          const ga_params = {
            eventCategory: 'Canzone',
            eventAction: 'preferito',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
            // ga('send', 'event', 'Canzone', 'preferito', 0, 0, { hitCallback: function () { } });
        });

        eventBus.on(EVENTS.PODCAST_SHARE, (content) => {
          const ga_params = {
            eventCategory: 'Podcast audio',
            eventAction: 'share',
            ga_eventLabel: 0,
            ga_eventValue: 0,
            ga_fieldsObject:{ hitCallback: function () { } }
          };
          const eventName = ga_params.eventCategory+' - '+ga_params.eventAction;
          this.gtag(HIT_TYPE, eventName, ga_params);
          // ga('send', 'event', 'Podcast audio', 'share', 0, 0, { hitCallback: function () { } });
        });

    }

    reset_google_analytics() {
        Utils.deleteCookie('_gid');
        Utils.deleteCookie('_ga');
        document.getElementById('atrframe').contentWindow.location.reload(true);
    }

    check_refresh_page() {

        if (window.__counterRefresh % window.tempo_di_refresh == 0) {

            if (window.refresh_active) {
                console.log("Refresh attivo");
                //TODO: lanciare evento
                checkPage(null, null, null, true);
            } else {
                console.log("Refresh non attivo");
                // this.google_analytics_send_page_view();
            }

        }

        ++window.__counterRefresh;

        if ((window.__counterRefresh % 6) != 0) {
            //  this.google_analytics_send_page_view();
        } else {
            //Riavvio sessione disabilitata
            if (!window.gaiframe) {
                ga('send', {
                    hitType: 'pageview',
                    'sessionControl': 'start',
                    page: location.pathname,
                    location: location.href,
                    title: document.title,
                    'hitCallback': function (data) {
                        console.log("Analytics inviato con riavvio sessione");
                    }
                });
            }
        }
    }

    google_analytics_send_page_view() {

        if (window.gaiframe) {
            return false;
        }

        gtag('send', {
            hitType: 'pageview',
            page: location.pathname,
            location: location.href,
            title: document.title,
            'hitCallback': function (data) {
                console.log("Analytics inviato senza riavvio sessione");
            }
        });

    }

    gtag(hitType,eventName, params){
      // GA_EVT_PARAMS.CMD, GA_EVT_PARAMS.HIT_TYPE, eventCategory, eventAction, ga_eventLabel,ga_eventValue, ga_fieldsObject
      try {
        gtag(hitType, eventName, params);
      }catch (e) {
        console.warn('gtag error:',e);
      }
    }

    async ttq(actionName, contents) {
      try {
        await ttq.track(actionName, contents);
        console.log('Tiktok event sent', actionName);
      } catch (e) {
        console.warn('ttq err:', e)
      }
    }

    ga(evcmd, hitType, eventCategory, eventAction, eventLabel, eventValue, fieldsObject){
      try{
        ga(evcmd, hitType, eventCategory, eventAction, eventLabel, eventValue, fieldsObject)
      }catch (e) {
        console.warn()
      }
    }

    fbq(trackType,eventName,eventParams={}){
      if(!window.fbq){
        fbEvents.push({trackType,eventName,eventParams})
        return;
      }else{
        fbq(trackType,eventName, eventParams);
        while(fbEvents.length){
          try {
            const event=fbEvents.shift();
            this.fbq(event.trackType,event.eventName, event.eventParams);
          } catch (error) {
           console.warn(error);
          }
        }
      }
    }

    initGenericListener(){
      eventBus.on(EVENTS.USER_LOGIN, async (e)=>{
        let additionalParams = {
          url: e.url,
        };

        await this.sendEventAnalytics('Engagement','login', additionalParams); //eventCategory, eventAction

        // this.webtrekk_send_event('Engagement - Login', { 1: 'Engagement - Login' });
        // this.ga('send', 'event', 'Engagement', 'login', e.url, 0, { hitCallback: function () { } });
        // this.fbq('trackCustom','Login');
      })

      eventBus.on(EVENTS.REGISTRAZIONE_START, async ()=>{

        await this.sendEventAnalytics('Engagement','registration - step1');

        // this.webtrekk_send_event('Engagement - registration - step1', { 1: 'Engagement - registration - step1' });
        // this.ga('send', 'event', 'Engagement', 'registration - step1');
        // this.fbq('trackCustom','Engagement - registration - step1');

      });

      eventBus.on(EVENTS.REGISTRAZIONE_CONFERMATA, async () => {

        await this.sendEventAnalytics('Engagement', 'registration - step2');

        // this.webtrekk_send_event('Engagement - registration - step2', { 1: 'Engagement - registration - step2' });
        // this.ga('send', 'event', 'Engagement', 'registration - step2');
        // this.fbq('trackCustom','Engagement - registration - step2');
      })

      eventBus.on(EVENTS.PARTECIPA_GIOCO_SEMPLICE ,async (e) => {
        //e.url
        const eventCategory = 'Engagement';
        let eventAction = 'startGame';
        if (user.getLocalUser()) {
          eventAction = 'startGame - loggato';
        }

        await this.sendEventAnalytics(eventCategory, eventAction);
      });

      eventBus.on(EVENTS.GIOCO_SEMPLICE_END, async (e) => {

        let additionalParams = {
          url: e.url,
        };

        await this.sendEventAnalytics('Engagement', 'endGame', additionalParams);

        // this.webtrekk_send_event('Engagement - endGame', { 1: 'Engagement - endGame' });
        // this.ga('send', 'event', 'Engagement', 'endGame', e.url, 0, { hitCallback: function () { } });
        // this.fbq('trackCustom','Engagement - endGame', {url:e.url});
        // fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_10%'});
      });

      eventBus.on(EVENTS.GIOCO_CUSTOM_CODICE, async (e)=>{

        let additionalParams = {
          url: e.url
        };

        await this.sendEventAnalytics('Engagement', 'percorso custom', additionalParams);

        // this.webtrekk_send_event('Engagement - percorso custom', { 1: 'Engagement - percorso custom' });
        // this.ga('send', 'event', 'Engagement', 'percorso custom', e.url, 0, { hitCallback: function () { } });
        // this.fbq('trackCustom','Engagement - percorso custom', {url:e.url});
        // fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_10%'});
      });

      eventBus.on(EVENTS.GIOCO_CUSTOM_NOCODICE, async (e)=>{

        let additionalParams = {
          url: e.url,
        };

        await this.sendEventAnalytics('Engagement', 'percorso semplice', additionalParams);
        // this.webtrekk_send_event('Engagement - percorso semplice', { 1: 'Engagement - percorso semplice' });
        // this.ga('send', 'event', 'Engagement', 'percorso semplice', e.url, 0, { hitCallback: function () { } });
        // this.fbq('trackCustom','Engagement - percorso semplice', {url:e.url});
        // fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_10%'});
      });

      eventBus.on(EVENTS.GIOCO_CUSTOM_CODICE_STEP2, async (e)=>{

        let additionalParams = {
          url:e.url,
          ga:{
            eventLabel:e.url,
            eventValue : 0,
            fieldsObject : { hitCallback: function () { } }
          }
        };

        await this.sendEventAnalytics('Engagement', 'percorso custom - codice', additionalParams);

        // this.webtrekk_send_event('Engagement - percorso custom - codice', { 1: 'Engagement - percorso custom - codice' });
        // this.ga('send', 'event', 'Engagement', 'percorso custom - codice', e.url, 0, { hitCallback: function () { } });
        // this.fbq('trackCustom','Engagement - percorso custom - codice', {url:e.url});
        // fbq('trackCustom', 'ShareDiscount', {promotion: 'share_discount_10%'});
      });

      eventBus.on(EVENTS.USER_AUTOLOGIN, async (e)=>{
        const eventCategory = 'Engagement';
        let eventAction='autoLogin';

        await this.sendEventAnalytics(eventCategory, eventAction);
      });

    }

    initTiktokListener(){
      eventBus.on(EVENTS.USER_AUTOLOGIN,async () => {
        try {
          let params = await this.getUserData();
          await ttq.identify(params);
        } catch (e) {
          console.warn('ttq not found', e);
        }
      });
    }

}

const analytics = new Analytics();

export default analytics;
